import { isQuestion } from "../../../../../../components/Questionnaire/Section/Question/types";
import { isNoCoverValue } from "../../../../../../components/Questionnaire/Section/Question/QuestionFactory/questions/PersonalisedCoverQuestion/constants";
import type {
  QuestionnaireState,
  UpdateAnswerPayload,
} from "../../../../types";

/**
 * Get the options for a primary question in a personalised_cover group
 */
export const getPrimaryQuestionOptions = (
  state: QuestionnaireState,
  primaryQuestionName: string,
): string[] => {
  const section = state.sections[state.currentSectionIndex];
  const question = section.questions
    .filter(isQuestion)
    .find(q => q.name === primaryQuestionName);

  return question?.options?.map(opt => opt.value) || [];
};

/**
 * Check if a value should be treated as "no" for personalised_cover groups
 * '0', 'no', or empty string are treated as "no"
 */
export const isPersonalisedCoverNo = (
  value: UpdateAnswerPayload["value"],
): boolean => {
  if (typeof value !== "string") return false;
  return isNoCoverValue(value);
};

/**
 * Check if a value is valid for a personalised_cover group
 * Value must be in the primary question's options
 */
export const isValidPersonalisedCoverValue = (
  value: UpdateAnswerPayload["value"],
  options: string[],
): boolean => {
  if (typeof value !== "string") return false;
  return options.includes(value);
};
